//here will be created all editors components and dialog for edit
import {
    DialogTitle, DialogContent, DialogActions,
    Button, Grid,
} from "@mui/material";
import * as React from "react";
import {useTranslation} from "react-i18next";
import makeStyles from "@mui/styles/makeStyles";
import * as _ from "lodash";

import {useDispatch, useSelector} from 'react-redux';
import {user} from "../../../store/reducers/user";
import {AdminAPI} from '../admin_api';
import {TextFieldDebounce} from '../../../controls/agyle/textFieldDebounce';
import CircularProgress from '@mui/material/CircularProgress';

const useStyles = makeStyles((theme) => ({
    dictRepresentationMissing: {
        color: "#FF6868",
        fontSize: "12px",
        cursor: "help",
        "& svg":{
            fontSize: "18px",
            marginLeft: "4px",
        }
    },
    listHeader: {
        backgroundColor: "#424242",
        backgroundImage: "linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05))",
        paddingLeft: "8px",
        fontSize: "smaller",
        paddingTop: "4px",
        position: "relative",
        top: "5px",
        borderRadius: "4px"
    },
    tagsList: {
        "& li": {
            paddingLeft: "4px",
            paddingRight: "4px",
            "&:first-of-type": {
                paddingLeft: "8px"
            },
            "& button": {
                padding: "0px"
            }
        }
    },
    newTagItem: {
        borderRadius: "20px",
        paddingRight: "8px",
        "& input": {
            padding: "7px 0px 7px 16px"
        }
    },
    tagListObjectAdd: {
        flexDirection: "row",
        alignItems: "center"
    },
    tagListButton: {
        display: "inline-flex"
    },
    tagListObjectInput: {
        marginBottom: "5px",
        marginRight: "5px"
    },
    inputColorPickerContainer: {
        marginLeft: "5px",
        marginRight: "-8px",
        "& fieldset": {
            borderRadius: "4px",
            borderWidth: "1px",
            borderColor: theme.palette.fieldsetBorderColor.primary,
            paddingBottom: "15px",
            "&:hover":{
                borderColor: theme.palette.fieldsetBorderColor.hover,
            }
        }
    },
    inputColorPickerLegend: {
        transform: "matrix(0.75, 0, 0, 0.75, -1, -2)",
        opacity: "0.75"
    },
    inputColorPickerText: {
        fontSize: "1rem",
        width: "calc(100% - 80px)",
        background: "transparent",
        border: "0px",
        color: theme.palette.text.primary,
        outline: "0px"
    },
    inputColorPickerColor: {
        width: "50px",
        border: "0px",
        outline: "0px",
        float: "right",
        height: "24px",
        cursor: "pointer"
    }
}));

export function DictionariesAdminMergeForm(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const [idToMerge, setIdToMerge] = React.useState("");
    const [idFromMerge, setIdFromMerge] = React.useState("");
    const [loading, setLoading] = React.useState(false);
    const [isInConfirm, setInConfirm] = React.useState(false);
    const [mergeObject, setMergeObject] = React.useState(null);
    const [inMerge, setInMerge] = React.useState(false);
    const userObject = useSelector(user);
    const defDateFormat = "YYYY-MM-DD HH:mm:ss";
    React.useEffect(()=>{
        if(props.record) {
            setIdFromMerge(props.record._id);
        }
    },[props.record]);

    React.useEffect(()=>{
        setLoading(true);
        setMergeObject(null);
        AdminAPI.getTableData(props.config.table, (new AbortController()).signal, {_id: idToMerge}, 0, 10, undefined, props.config.apiConfigName).then(function (tableData) {
            let retRecords;
            if (tableData.length == 1) {
                console.log(JSON.stringify(tableData[0]));
                setMergeObject(tableData[0])
            }
            setLoading(false);
        }, (error) => {
            setLoading(false);
            console.log(error);
        });
    },[idToMerge]);

    const handleCancel = (event) => {
        if(isInConfirm) {
            setInConfirm(false);
        }else {
            props.handleCancel(event);
        }
    }

    const handleMerge = (event) => {
        if(!isInConfirm) {
            setInConfirm(true)
        } else {
            props.merge(idFromMerge,idToMerge);
            setInMerge(true);
        }
    }


    return (

        <React.Fragment>
            {props.record &&
            <React.Fragment>
                <DialogTitle>
                    {t("Merge record: ")+idFromMerge}
                </DialogTitle>
                <DialogContent>
                <Grid container>
                    {!isInConfirm && <Grid item xs={24}>
                        {loading && <
                            div style={{position: 'absolute',display: 'flex',top: '15px',right: '20px'}}>
                                <CircularProgress color="inherit" size={32}/>
                            </div>
                        }
                        {(idToMerge.length>0 && mergeObject ==null) &&
                            <div>{`Record not found for id '${idToMerge}'`}</div>
                        }
                        {(idToMerge.length>0 && mergeObject!=null) &&
                            <React.Fragment>
                                <div>{`Record to merge:`}</div>
                                <div>{`Id: ${mergeObject._id}`}</div>
                                <div>{`First Name: ${mergeObject.firstName}`}</div>
                                <div>{`Family Name: ${mergeObject.familyName}`}</div>
                            </React.Fragment>
                        }
                        <TextFieldDebounce
                            id={_.uniqueId("edit_")}
                            sx={{ m: 1, width: '100%' }}
                            variant="outlined"
                            value={idToMerge}
                            onChange={(event) => {
                                setIdToMerge(event.target.value)
                            }}
                            label="Record id to merge"
                        />
                    </Grid>}
                    {isInConfirm && <Grid item xs={24}>
                        {(mergeObject==null) &&
                            <React.Fragment>
                                <div>{`Record not found for id '${idToMerge}'`}</div>
                                <div>{`If you proceed record ${idFromMerge} will be changed to '${idToMerge}`}</div>
                                <div>{t('Click merge to proceed')}</div>
                            </React.Fragment>
                        }
                        {(mergeObject!=null) &&
                            <React.Fragment>
                                <div>{`Are you sure to merge '${idFromMerge} to:'`}</div>
                                <div>{`Id: ${mergeObject._id}`}</div>
                                <div>{`First Name: ${mergeObject.firstName}`}</div>
                                <div>{`Family Name: ${mergeObject.familyName}`}</div>
                                <div>{`Record '${idFromMerge} will be deleted'`}</div>
                            </React.Fragment>
                        }
                    </Grid>}
                </Grid>
                </DialogContent>
                <DialogActions>
                <Button onClick={handleCancel}>
                    {t("Cancel")}
                </Button>
                <Button onClick={handleMerge} disabled={idToMerge.length==0 || inMerge}>
                    {t("Merge")}
                </Button>
                </DialogActions>
            </React.Fragment>
            }
        </React.Fragment>
    )
}